import { TimeInForce } from "@goodfill/domain-properties/src";
import React from "react";

export const TimeInForceComponent = (props: { value: TimeInForce }) => (
  <>
    {props.value === TimeInForce.Immediate
      ? "Immediate"
      : props.value === TimeInForce.CustomToday
      ? "Custom Today"
      : props.value === TimeInForce.CustomFuture
      ? "Custom Future"
      : props.value}
  </>
);
